import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { unlinkPaymentMerchant } from '../requests/unlink-payment-merchant.js';
import { refreshAfterUnlink } from './bank-match-cache.js';

export const useUnlinkPaymentMerchantMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unlinkPaymentMerchant,
    onSettled: () => refreshAfterUnlink(queryClient),
  });
};
